import axios from "../axiosInstance"

export const getIntegrityCheck = async (dealIdStr: string) => {
  try {
    const res = await axios.get(`/legacy-bridge/deals/${dealIdStr}/integrity-check`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch integrity check")
    }
    return data as {
      success: boolean
      dealIdStr: string
      inSync: boolean
      v3UpdatedAt: string | null
      legacyOGLastModDate: string | null
      legacySource: string | null
      mismatchedFields: { field: string; v3Value: any; legacyValue: any }[]
    }
  } catch (error) {
    console.error("Error fetching integrity check:", error)
    throw error
  }
}

export const getCompanyIntegrityCheck = async (companyId: number) => {
  try {
    const res = await axios.get(`/legacy-bridge/company/${companyId}/integrity-check`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch company integrity check")
    }
    return data as {
      success: boolean
      companyId: number
      companyName: string
      legacyId: number | null
      inSync: boolean
      items: { label: string; v3Count: number; legacyCount: number; inSync: boolean }[]
    }
  } catch (error) {
    console.error("Error fetching company integrity check:", error)
    throw error
  }
}
